import axios from 'axios';
import * as Constants from '../common/constants';
import * as HelperFunctions from '../common/functions/helperFunctions';

class DisposalPlacesService {

  constructor(lang?) {
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Pragma: 'no-cache',
      "langId": HelperFunctions.getLangId(lang)
    }
  }

  getAllDisposalPlaces(searchedString: string) {
    return axios({
      url: `${Constants.apiUrl}/disposalPlaces/getAll/`,
      method: 'post',
      data: JSON.stringify(searchedString)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

}

export default DisposalPlacesService;